export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  FLOWS: '/flows',
  FLOW_EDIT: (flowId: string) => `/flows/${flowId}`,
  CONVERSATIONS: '/conversations',
} as const
